<template>
  <div class="text-truncate-wrapper">
    <div
      ref="textEl"
      class="text-truncate"
      :class="{ 'text-truncate--expanded': isExpanded }"
      :style="truncateStyles"
    >
      <slot />
    </div>

    <Button
      v-if="showButton && isTruncated && !isExpanded"
      name="ещё"
      type="button"
      theme="link"
      :collapsed="true"
      size="l"
      class="text-truncate__more-btn"
      @click.native="expand"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, nextTick, onMounted, ref, watch } from 'vue';

import Button from '~/components/controls/Button.vue';

const props = defineProps({
  showLines: {
    type: [Number, String],
    default: 1,
  },
  showButton: {
    type: Boolean,
    default: false,
  },
});

const textEl = ref<HTMLElement | null>(null);
const isExpanded = ref(false);
const isTruncated = ref(false);

const truncateStyles = computed(() => {
  if (isExpanded.value) {
    return {
      '-webkit-line-clamp': 'unset',
    };
  }

  return {
    '-webkit-line-clamp': String(props.showLines),
  };
});

const checkTruncation = () => {
  if (!textEl.value) return;

  const wasExpanded = isExpanded.value;
  isExpanded.value = false;

  nextTick(() => {
    const el = textEl.value;
    if (!el) return;

    // Проверяем, обрезан ли контент по высоте
    isTruncated.value = el.scrollHeight > el.clientHeight;

    // Возвращаем исходное состояние
    isExpanded.value = wasExpanded;
  });
};

const expand = () => {
  isExpanded.value = true;
};

// Проверяем после монтирования
onMounted(() => {
  nextTick(checkTruncation);
});

watch(
  () => props.showLines,
  () => {
    nextTick(checkTruncation);
  }
);
</script>

<style lang="scss" scoped>
.text-truncate-wrapper {
  display: inline-flex;
  align-items: flex-start;
}

.text-truncate {
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  height: min-content;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; // переопределяется стилем
  line-clamp: 1;
}

.text-truncate--expanded {
  overflow: visible;
  text-overflow: initial;
  display: block;
  -webkit-box-orient: initial;
  -webkit-line-clamp: initial;
  line-clamp: initial;
}

.text-truncate__more-btn {
  flex: 0 0 auto;
  align-self: flex-end;
  margin-left: 4px;
  color: $color-brand;
  height: min-content !important;
}
</style>
